import React from 'react';
import { connect } from 'react-redux';
import {handleLiveConsoleReturn} from '../js/live-console';
import CybsButton from '@cybs-ui/components/lib/button';
var selectedSampleCode = {'label':'LiveConsole', 'value':'LiveConsole'};


/**
 * Request description in live console tab 
 */


class ReturnToLiveConsole extends React.Component {

    render() {

        selectedSampleCode = (this.props.selectedSampleCode == undefined) ?  {
            'label':'LiveConsole',
            'value':'Live Console'
        }: this.props.selectedSampleCode;

        return (
            <div class = "returnToLiveConsole"style={{margin:'5px', marginLeft: 'auto'}}>
                {
                    (selectedSampleCode["value"] !== "Live Console") &&
                    <CybsButton
                        dataTest="button-live-console-return"
                        id="button-live-console"
                        i18n={{ label: 'Return to Live Console' }}
                        colorScheme="secondary"
                        onClick={handleLiveConsoleReturn}
                    />
                }
            </div>
        );

    }
}
function mapStateToProps(state) {

    return {
        path :state.lhsReducer.path,
        selectedSampleCode: state.examplesReducer.selectedSampleCode

    };

}

export default connect(mapStateToProps)(ReturnToLiveConsole);